import React from 'react';
import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { TextBox } from '@apply/components';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const FirstNameField: React.FC = () => {
    const firstName = useBrokerDetailsStore((s) => s.firstName);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const isAdmin = useBrokerDetailsStore((s) => s.isAdmin);
    const changed = useBrokerFieldFieldChanged(FormField.FirstName);

    return (
        <>
            <TextBox
                id='firstName'
                value={firstName}
                onChange={(v) => updateFields({ firstName: v })}
                label='First Name'
                required
                width={'100%'}
                readOnly={!isAdmin}
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon
                    icon='asterisk'
                    className='required-icon'
                />
            </ShowIf>
        </>
    );
};
